import { ApiClient, ApiResponse, ServiceBase } from './api'

import { WarehouseArea } from '@/types/warehouse'

// 创建库区请求接口
export interface CreateAreaRequest {
  warehouseId?: number
  name: string
  code: string
  description?: string
  positionCount?: number // 自动生成库位数量
  positionPrefix?: string // 库位前缀
}

export class WarehouseService extends ServiceBase {
  constructor(client: ApiClient) {
    super(client, '/v2/warehouse')
  }

  // 库区管理 (Areas)
  async getWarehouseAreas(warehouseId?: number) {
    const params = warehouseId ? { warehouse_id: warehouseId } : {}
    return this.get<ApiResponse<WarehouseArea[]>>('/areas', { params })
  }

  // 创建库区（批量库位）
  async createWarehouseArea(data: CreateAreaRequest) {
    return this.post<ApiResponse>('/area', data)
  }

  // 删除库区
  async deleteWarehouseArea(id: number) {
    return this.delete<ApiResponse>(`/area/${id}`)
  }
}

export default WarehouseService
